import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafCheckboxField } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/checkbox-field/checkbox-field';

@Component({
  selector: 'cigna-leaf-checkbox-field',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styles: `
    :host ::ng-deep cigna-leaf-checkbox-field-item {
      margin-bottom: calc(var(--size-base-unit)* 1);
    }
    :host ::ng-deep cigna-leaf-checkbox-field-item:last-child {
      margin-bottom: 0;
    }
  `,
  template: `
    <leaf-checkbox-field
      [label]="label"
      [fieldNote]="fieldNote"
      [fieldNoteIsSuccess]="fieldNoteIsSuccess"
      [fieldNoteIsError]="fieldNoteIsError"
      [isOptional]="isOptional"
      [optionalText]="optionalText"
    >
      <ng-content></ng-content>
    </leaf-checkbox-field>
  `,
})
export class CignaLeafCheckboxFieldComponent {
  @Input() label: LeafCheckboxField['label'] = '';
  @Input() fieldNote: LeafCheckboxField['fieldNote'];
  @Input() fieldNoteIsSuccess: LeafCheckboxField['fieldNoteIsSuccess'] = false;
  @Input() fieldNoteIsError: LeafCheckboxField['fieldNoteIsError'] = false;
  @Input() isOptional: LeafCheckboxField['isOptional'] = false;
  @Input() optionalText: LeafCheckboxField['optionalText'];
}
